import React, { useState } from 'react'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { AlertIcon } from 'src/assets/icons'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import { voidACheck } from 'src/app/shared/services/ViewTransactionService'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { NotificationInstance } from 'antd/es/notification/interface'

export interface ModalProps {
  isOpen: boolean
  onCancel?: () => Promise<any> | void
  onClose: () => void
  checkNumber: string
  id: string
  notiApi: NotificationInstance
  onGridReady?: () => any
}

const VoidACheckModal = (props: ModalProps) => {
  const { isOpen, onClose, checkNumber, id, notiApi, onGridReady } = props
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const handleConfirm = async () => {
    try {
      if (id) {
        setLoading(true)
        const response = await voidACheck(id)

        if (response?.statusCode === 'Success') {
          notiApi.success({
            message: (
              <RichTextField
                richText={t('SystemMessages:' + SYSTEM_MESSAGE_IDS.CHECK_NUMBER_VOID_SUCCESSFULLY, {
                  checkNumber,
                })}
              />
            ),
            closeIcon: null,
          })
        }
      }
    } catch (e) {
    } finally {
      onGridReady?.()
      onClose()
      setLoading(false)
    }
  }

  return (
    <ActionConfirmationModal
      title={t('TransactionResult:modal.title.voidACheck')}
      description={<RichTextField richText={t('TransactionResult:modal.description.voidACheck', { checkNumber })} />}
      descriptionType='string'
      footer={[
        <Button type='default' onClick={onClose} disabled={loading} key={'cancel'}>
          {t('common:no')}
        </Button>,
        <Button type='primary' key={'confirm'} onClick={handleConfirm} disabled={loading} loading={loading}>
          {t('common:yes')}
        </Button>,
      ]}
      isOpen={isOpen}
      onClose={onClose}
      icon={<AlertIcon width={80} height={80} />}
    />
  )
}

export default VoidACheckModal
